// pathReducer.ts
import { PathActionTypes, SET_PREVIOUS_PATH } from './path';

interface PathState {
    previousPath: string | undefined;
}

const initialState: PathState = {
    previousPath: undefined
};

const pathReducer = (state = initialState, action: PathActionTypes): PathState => {
    switch (action.type) {
        case SET_PREVIOUS_PATH:
            return {
                ...state,
                previousPath: action.payload
            };
        default:
            return state;
    }
};

export default pathReducer;
